import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import ViewMessage from '../../components/ViewMessage';
import s from './ViewMessage.css';
const ViewMessageContainer = ({ threadId, userType }) => {

  return (
    <div className={s.bgColor}>
      <div className={s.container}>
        <div className={s.root}>
          <ViewMessage threadId={threadId} userType={userType} />
        </div>
      </div>
    </div>
  );

}

ViewMessageContainer.propTypes = {
  threadId: PropTypes.number.isRequired,
  userType: PropTypes.string.isRequired
};

export default withStyles(s)(ViewMessageContainer);
